import React from 'react';
import { Logo } from '@plerionhq/design-system';
import {
  ArrowTopRightOnSquareIcon,
  XMarkIcon,
} from '@heroicons/react/24/solid';
import { useLocation } from 'react-router-dom';

import { useTranslation, Trans } from 'react-i18next';

interface EnvironmentPanelProps {
  onDismiss: () => void;
}

export function EnvironmentPanel({ onDismiss }: EnvironmentPanelProps) {
  const { t } = useTranslation('containerInterface');
  const location = useLocation();

  return (
    <div
      className={`${location.pathname.startsWith('/admin/') ? 'm-4' : 'mx-4 mt-4'} rounded-panel border-container-border flex items-center justify-between gap-4 border bg-white p-4 dark:bg-gray-800`}
    >
      <div className="flex flex-row items-center">
        <Logo name="Plerion" />
        <div className="pl-4">
          <div className="text-action-primary text-lg font-semibold">
            {t('productionNonProductionYouDecide')}
          </div>
          <div>
            <Trans
              t={t}
              i18nKey="classifyYourIntegrationsAndExplorePlerionWith"
              components={{
                a: (
                  <a
                    href="https://docs.plerion.com/guides/platform/environments"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hyperlink inline-flex items-center gap-1"
                    onClick={onDismiss}
                  />
                ),
                icon: <ArrowTopRightOnSquareIcon className="h-4 w-4" />,
              }}
            />
          </div>
        </div>
      </div>
      <button onClick={onDismiss}>
        <XMarkIcon className="h-5 w-5 text-gray-400 hover:text-gray-700 dark:hover:text-gray-300" />
      </button>
    </div>
  );
}
